import { Component, OnInit, ElementRef } from '@angular/core';
import { SiteConfigurationService } from '../../common/site-configuration.service'; 

@Component({
  selector: 'tn-facebook-widget',
  templateUrl: '../../themes/default/html/tnfacebookwidget.component.html',
  styleUrls: ['../../themes/default/css/tnfacebookwidget.component.scss']
})
export class TnfacebookwidgetComponent implements OnInit {

  facebookUrl: any;
  _mySettings: any;
  FBSettings: any;

  constructor(private mySettings: SiteConfigurationService, private elementRef:ElementRef) {

    this._mySettings = mySettings.getFullConfig();
    //this.facebookUrl = this._mySettings.e400.externals.facebook.pageUrl;
    this.FBSettings = this._mySettings.e400.externals.facebook;
    this.CreateReference();

  }

  ngOnInit() {

  }

   checkLoad = function () {
        if (this.FBSettings != {}) {
            return true;
        } else {
            return false;
        }
    };

  CreateReference() {

      var s;
      try {
          s = document.createElement("script");
      } catch (e) {
          return;
      }
      s.id = "FacebookSI";
      s.type = "text/javascript";
      s.src="./assets/tn_facebook_init.js";
      this.elementRef.nativeElement.appendChild(s);
      
  }
}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnfacebookwidget/tnfacebookwidget.component.ts